@if (isRmbRmc) {
<p>{{ "RENEWAL_TEXT" | globalTranslate }}</p>
}
<p class="person-label">{{ selectedIndividual | fullname }}</p>
<nh-form
  [topLevelName]="'dec'"
  [individuals]="checkForDropdown ? finalListIndvs : individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  class="label-section"
  topLevelQuestion="{{ 'DEPENDENT_CARE_STATIC_TEXT1' | globalTranslate }}"
  [individualQuestion]="this.individualQues | globalTranslate"
  [individualQuestionAria]="
    this.translateService.getDefaultLang() === 'en'
      ? (this.individualQuesAriaEn | globalTranslate)
      : this.individualQuesAriaSp
  "
  popupText="{{ 'DEPENDENT_CARE_STATIC_TEXT2' | globalTranslate }}"
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    <div [formGroup]="getControl('data.dependantCareInformation')">
      <br />
      <h1 class="section-header">
        {{ "DEPENDENT_CARE_STATIC_TEXT3" | globalTranslate }}
      </h1>
      <hr />
      <nh-field
        id="dec_dependantIndivNumber"
        label="{{ 'DEPENDENT_CARE_STATIC_TEXT4' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="dependantIndivNumber"
          [attr.aria-label]="'DEPENDENT_CARE_STATIC_TEXT4' | globalTranslate"
          [attr.disabled]="isReadOnlyDependent"
          [items]="indi"
          bindValue="identifier"
          bindLabel="name.fullName"
          formControlName="dependantIndivNumber"
          (change)="setIndiv()"
          required
        ></select>
      </nh-field>

      @if (isEnabled('data.dependantCareInformation.personOutOfHouseholdName'))
      {
      <nh-field
        id="dec_personOutOfHouseholdName"
        label="{{ 'DEPENDENT_CARE_STATIC_TEXT5' | globalTranslate }}"
        class="label-section"
      >
        <input
          type="text"
          [attr.aria-label]="'DEPENDENT_CARE_STATIC_TEXT5' | globalTranslate"
          class="form-control"
          formControlName="personOutOfHouseholdName"
          required
        />
      </nh-field>
      }
    </div>

    <div [formGroup]="getControl('data.expensePaymentInformation')">
      <nh-field
        id="dec_expenseAmount"
        label="{{ 'DEPENDENT_CARE_STATIC_TEXT6' | globalTranslate }} {{
          selectedIndividual | fullname
        }} {{ 'DEPENDENT_CARE_STATIC_TEXT7' | globalTranslate }}"
        class="label-section"
        [col9]="true"
      >
        <nh-popover
          style="padding-left: 3px"
          content="{{ 'DEPENDENT_CARE_STATIC_TEXT9' | globalTranslate }}"
        ></nh-popover>
        <div class="hint">
          {{ "DEPENDENT_CARE_STATIC_TEXT8" | globalTranslate }}
        </div>
        <nh-input-group prepend="$">
          <input
            nh
            type="decimal"
            [attr.aria-label]="
              ('DEPENDENT_CARE_STATIC_TEXT6' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('DEPENDENT_CARE_STATIC_TEXT7' | globalTranslate)
            "
            maxlength="7"
            name="expenseAmount"
            formControlName="expenseAmount"
            class="form-control"
            required
          />
        </nh-input-group>
      </nh-field>
      <nh-field
        id="dec_expenseFrequencyCode"
        label="{{ 'DEPENDENT_CARE_STATIC_TEXT10' | globalTranslate }} {{
          selectedIndividual | fullname
        }} {{ 'DEPENDENT_CARE_STATIC_TEXT11' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="expenseFrequencyCode"
          [attr.aria-label]="
            ('DEPENDENT_CARE_STATIC_TEXT10' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('DEPENDENT_CARE_STATIC_TEXT11' | globalTranslate)
          "
          [items]="
            tableCodeValue(
              'INCEXPPAYFREQUENCY',
              'data.expensePaymentInformation.expenseFrequencyCode'
            )
          "
          formControlName="expenseFrequencyCode"
          required
        ></select>
      </nh-field>
    </div>
  </section>
</nh-form>